import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import { msalConfig, loginRequest, NO_IFRAME } from "@/lib/msal-config";

export const msalInstance = new PublicClientApplication(msalConfig);

export async function syncTokenCookie(
  accessToken: string,
  fetchFn: typeof fetch = globalThis.fetch,
) {
  const response = await fetchFn("/api/auth/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ accessToken }),
  });

  if (!response.ok) {
    throw new Error("Failed to sync Microsoft session cookie");
  }
}

export async function refreshToken(
  fetchFn: typeof fetch = globalThis.fetch,
): Promise<boolean> {
  await msalInstance.initialize();
  const account = msalInstance.getAllAccounts()[0];
  if (!account) return false;

  try {
    const result = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
      ...NO_IFRAME,
    });
    await syncTokenCookie(result.accessToken, fetchFn);
    return true;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ ...loginRequest, account });
    }
    return false;
  }
}
